const Social = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_360_22251)">
        <path d="M8.85156 10.4498L15.6516 7.0498" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
        <path d="M8.85156 13.9502L15.6516 17.3502" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
        <path
          d="M5.25 16.25C7.45914 16.25 9.25 14.4591 9.25 12.25C9.25 10.0409 7.45914 8.25 5.25 8.25C3.04086 8.25 1.25 10.0409 1.25 12.25C1.25 14.4591 3.04086 16.25 5.25 16.25Z"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M19.25 9.25C21.4591 9.25 23.25 7.45914 23.25 5.25C23.25 3.04086 21.4591 1.25 19.25 1.25C17.0409 1.25 15.25 3.04086 15.25 5.25C15.25 7.45914 17.0409 9.25 19.25 9.25Z"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M19.25 23.25C21.4591 23.25 23.25 21.4591 23.25 19.25C23.25 17.0409 21.4591 15.25 19.25 15.25C17.0409 15.25 15.25 17.0409 15.25 19.25C15.25 21.4591 17.0409 23.25 19.25 23.25Z"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_360_22251">
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Social;
